(function () {
  if (!window.Lenis || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var lenis = new window.Lenis({
    duration: 1.1,
    easing: function (t) {
      return Math.min(1, 1.001 - Math.pow(2, -10 * t));
    },
    smoothWheel: true,
    smoothTouch: false
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
  window.FleuraLenis = lenis;
})();
